export default __webpack_public_path__ + "images/20510e7c8c94b53f0174e5113f0ad79a-eventbritecircle_logo.svg";